import { useQuery } from '@tanstack/react-query';
import { getTopWorkflows } from '@/services/composer-dashboard/get-top-workflows';
import { useOrgStore } from '@/stores/org-store';

export const useGetTopWorkflows = (labelIds?: string[]) => {
  const { currentOrg } = useOrgStore();
  const orgId = currentOrg?.orgid;

  return useQuery({
    queryKey: ['top-workflows', orgId, labelIds ?? []],
    queryFn: () => getTopWorkflows(orgId!, labelIds),
    enabled: !!orgId,
    staleTime: 60 * 1000,
  });
};
